export default __webpack_public_path__ + "static/media/m-signup-17-tour-pg-4.6e464c8d.jpg";